/**
 * Action type constants for the Document Artifact system.
 *
 * The artifact system provides generic document state management (commit,
 * undo, redo, load, reset) keyed by artifact ID. Multiple artifacts can
 * coexist simultaneously (e.g., a subtitle editor and a document editor).
 */

export const ARTIFACT_LOAD = 'ARTIFACT_LOAD';
export const ARTIFACT_COMMIT = 'ARTIFACT_COMMIT';
export const ARTIFACT_UNDO = 'ARTIFACT_UNDO';
export const ARTIFACT_REDO = 'ARTIFACT_REDO';
export const ARTIFACT_SET_DIRTY = 'ARTIFACT_SET_DIRTY';
export const ARTIFACT_RESET = 'ARTIFACT_RESET';
